export default __webpack_public_path__ + "static/media/btcusdt.205f3138.png";